import { useEffect, useState } from 'react';

import { ScanningPeakMatrixInfo } from '../../../../interfaces/entity-dashboard/ScanningPeakMatrix';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';

type UseScanningPeakMatrixParams = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

type UseScanningPeakMatrixReturn = {
  matrix: ScanningPeakMatrixInfo | null;
};

export const useScanningPeakMatrix = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseScanningPeakMatrixParams): UseScanningPeakMatrixReturn => {
  const [matrix, setMatrix] = useState<ScanningPeakMatrixInfo | null>(null);

  const getScanningPeakMatrix = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);
    const data = await entityDashboardService.getScanningPeakMatrix({
      ...dateRange,
      solutionType: solutionTypeFilter,
    });

    setMatrix(data);
  };

  useEffect(() => {
    getScanningPeakMatrix();
  }, [dateRangePreset, solutionTypeFilter]);

  return { matrix };
};
